import React from 'react'
import './DashedLineHr.scss'

function DashedLineHr() {
  return <div className="wallet__line-hr" />
}

export default DashedLineHr
